<template>
  <div class="row py-5" id="como-o-rendimento-vai-alem-das-aparencias">
    <div class="col-12 col-md-12 mx-auto">
      <div class="container-xxl">

        <div class="our-stores">
          <div class="left-side">
            <h2 class="title">Como o <strong>Rendimento</strong> vai além das aparências</h2>
            <div class="mockup-card">
              <img src="@/assets/images/cartao.jpg" alt="cartao">
              <p>{{name}}</p>
              <div class="card-form">
                <h5>Seja mais que um colaborador.<br>Seja um parceiro!</h5>
                  <input type="text" placeholder="Qual o seu nome?" v-model="valueName" @keypress.enter="valueName ? name = valueName : ''" class="form-control rounded-xl border-color-2 mb-4" />
                  <button type="button" id="b-name" class="btn btn-color-1 rounded-xl text-color-2 px-4" @click="valueName ? name = valueName : ''">
                    Enviar
                  </button>
              </div>
            </div>
          </div>
          <div class="right-side">
            <div class="map">
              <div><img src="@/assets/images/map.png" alt=""></div>
              <div class="map-text">
                <h5>Conheça nossas lojas</h5>
                <p>A Cotação Rendimento/câmbio possui mais de 29 lojas espalhadas pelo Brasil. Conheça as nossas unidades!</p>
                <a href="https://www.cotacao.com.br/nossas-lojas/" target="_blank">Procurar</a>
              </div>
            </div>

            <div class="operations">
            <img src="@/assets/images/operation(2).png" alt="">
            <img src="@/assets/images/operation(3).png" alt="">
            <img src="@/assets/images/operation(1).png" alt="">
            </div>

            <div class="values">
              <div class="swiper-container swiper mySwiper" ref="mySwiper2">
                <div class="swiper-wrapper">
                  <div class="swiper-slide">
                      <img src="@/assets/images/values(1).png" alt="">
                  </div>
                  <div class="swiper-slide">
                    <div class="values-images">
                      <img src="@/assets/images/values(2).png" alt="">
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="values-images">
                      <img src="@/assets/images/values(3).png" alt="">
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="values-images">
                      <img src="@/assets/images/values(4).png" alt="">
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="values-images">
                      <img src="@/assets/images/values(5).png" alt="">
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="values-images">
                      <img src="@/assets/images/values(6).png" alt="">
                    </div>
                  </div>
                </div>
              </div>

              <div
                style="color: #00CFD9"
                class="swiper-button-prev swiper-button-prev2"
                ref="swiper-button-prev2"></div>
              <div
                style="color: #00CFD9"
                class="swiper-button-next swiper-button-next2"
                ref="swiper-button-next2"></div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
// import Swiper styles
import "swiper/swiper-bundle.css";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper/core";
// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Autoplay]);

export default {
  name: "home",

  data() {
    return {
      name:'Nome Completo',
      valueName:''
    };
  },

  components: {
  },

  mounted() {
    this.start();
  },

  computed: {},

  methods: {
    start() {
      setTimeout(() => {
        var swiper3 = new Swiper(this.$refs["mySwiper2"], {
          slidesPerView: 1,
          spaceBetween: 10,
          navigation: {
            nextEl: this.$refs["swiper-button-next2"],
            prevEl: this.$refs["swiper-button-prev2"],
          },
          breakpoints: {
            640: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
            768: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
            1024: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
          },
        });
      }, 150);
    },

  },
};
</script>

<style lang="scss" scoped>
#como-o-rendimento-vai-alem-das-aparencias {
  background: #ffffff;
  padding: 0 40px;
  @media screen and (max-width: 1100px) {
    padding: 0;
  }
}

.values{
  position: relative;
}

.swiper-button-prev,
.swiper-button-next {
  color: #fff;
  border-radius: 100px;
  border: 1px solid #fff;
  width: 3rem;
  height: 3rem;
  &::after {
    font-size: 1.5rem;
  }
}
.swiper-button-prev {
  opacity: 0;
  transform: translateY(25px);
  left: 10px;
}
.swiper-button-next {
  opacity: 0;
  transform: translateY(25px);
  right: 10px;
}
.swiper-button-prev2,
.swiper-button-next2 {
  width: 3rem;
  height: 3rem;
  border-radius: 100%;
  ::after {
    font-size: 1.3rem !important;
  }
}
.swiper-button-prev2 {
  transform: translateY(25px);
  left: 10px;
}
.swiper-button-next2 {
  transform: translateY(25px);
  right: 10px;
}

.our-stores {
  display: flex;
  justify-content: stretch;
  flex-wrap: wrap;

  .left-side {
    width: 40%;
    text-align: left;
    padding-right: 30px;

    @include media-breakpoint-down(md) {
      width: 100%;
      padding-right: 0;
    }

    h2 {
      font-size: 36px;
      color: #0a1d6f;
      font-weight: 400;
      strong {
        color: #00cfd9;
        font-weight: bold;
      }
    }

    .mockup-card {
      height: calc(100% - 94px);
      position: relative;

      @include media-breakpoint-down(md) {
        height: 600px;
      }

      img {
        width: 100%;
        height: 100%;
        border-radius: 20px;
      }
      p {
        position: absolute;
        margin: 0;
        color: #fff;
        font-size: 18px;
        top: 35%;
        left: 33%;
      }

      .card-form {
        position: absolute;
        margin: 0;
        background-color: #fff;
        border-radius: 20px;
        padding: 19px 17px;
        top: 50%;
        left: 9%;
        right: 6%;

        h5 {
          color: #0a1d6f;
          margin-bottom: 20px;
        }
      }
    }

    @media (max-width: 600px) {
      .mockup-card {
        .card-form {
          max-width: 280px;
          margin: 10px 0;
        }
      }
    }
  }
  .right-side {
    width: 60%;
    background-color: #f5f5f5;
    border-radius: 20px;
    padding: 20px;
    height: auto;

    .map {
      display: flex;

      img {
        height: 100%;
        object-fit: cover;
      }

      .map-text {
        background-color: #fff;
        text-align: left;
        padding: 20px;
        border-top-right-radius: 11px;
        border-bottom-right-radius: 11px;

        h5 {
          color: #00cfd9;
        }

        p {
          font-size: 13px;
          color: #0a1d6f;
        }
        a {
          background-color: #0a1d6f;
          color: #00cfd9;
          text-decoration: none;
          padding: 5px 17px;
          font-size: 12px;
          border-radius: 12px;

          &:hover {
            background-color: #00cfd9;
            color: #0a1d6f;
            font-weight: bold;
          }
        }
      }
    }
    .operations {
      display: flex;
      justify-content: space-between;
      padding: 20px 0;

      @include media-breakpoint-down(sm){
        padding: 20px 20px 0 20px;
      }

      img {
        width: 30%;
      }
    }

    .values {
      @include media-breakpoint-down(sm){
        padding: 20px;
      }

      img {
        width: 100%;
      }
    }

    @include media-breakpoint-down(sm) {
      width: 100%;
      padding: 0;

      .map {
        margin-top: 10px;
        img {
          display: none;
        }

        .map-text {
          padding: 11px;
          margin: 0 20px;
          border-radius: 10px;
        }
      }
      .operations {
        flex-wrap: wrap;
      }
    }

    @media (max-width: 568px) {
      margin-top: 20px;
    }
  }
}

</style>
